module.exports = __webpack_public_path__ + "img/详细解决方案_02.0cc0674e.svg";